import axios from "axios";
import store from "@/store";
import i18n from "@/lang";
import { Toast } from "vant";
import { removeToken } from "@/utils/auth";
import router from "@/router";
import { LOGIN } from "@/config/global_data";
// import { LANGUAGE_TYPE } from '@/config/global_data'

const la = navigator.language.toLowerCase();
let language = "en";
if (la.indexOf("zh") != -1) language = "zh";
const URL = window.global;
let BASE_URL = URL[Object.keys(URL)[0]];
for (let key in URL) {
  if (key == language) BASE_URL = URL[key];
}
const instance = axios.create({
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
  baseURL: BASE_URL,
  timeout: 30000, // request timeout
});

// request拦截器
instance.interceptors.request.use(
  (config) => {
    // Toast.loading({
    //   message: `${i18n.t('加载中')}...`,
    // })
    const { token, language } = store.getters;
    if (token) {
      config.headers["X-Api-Key"] = token;
      LOGIN.action = "login";
      LOGIN.access_token = token;
    }
    config.headers["device"] = "h5";
    // config.headers['lang'] = language || LANGUAGE_TYPE[0].value
    config.headers["lang"] = language || "en";
    return config;
  },
  (error) => {
    Toast.clear();
    console.error(error); // for debug
    return Promise.reject(error);
  }
);

// respone拦截器
instance.interceptors.response.use(
  (response) => {
    // Toast.clear()
    const res = response.data;
    if (res.code !== 200) {
      // : Illegal token; : Other clients logged in; 401: Token expired;
      if (res.code === 401) {
        removeToken();
        Toast(
          `${i18n.t("您还未登录，请先登录")}` ||
            `${i18n.t("登录")} ${i18n.t("过期")}`
        );
        store.dispatch("resetInfo").then(() => {
          // location.reload()
          console.log("重新加载");
          router.push("/home");
        });
        return Promise.reject(res);
      } else if (res.code === 503) {
        router.push("/maintenance");
      } else {
        Toast({
          message: res.message || "Error",
          duration: 3 * 1000,
        });
      }
      return Promise.reject(new Error(res.message || "Error"));
    } else {
      // 携带response响应头版本信息
      // const { headers } = response
      // res['kv'] = headers.kv || ''
      // store.dispatch('app/setServiceTime', headers['service-time'])
      return res;
    }
  },
  (error) => {
    Toast.clear();
    Toast({
      message: error.message,
      duration: 3 * 1000,
    });
    return Promise.reject(error);
  }
);

// GET请求
export const requestGet = (url, params) => instance.get(url, { params });
// DELETE请求
export const requestDelete = (url, params) => instance.delete(url, { params });
// POST请求
export const requestPost = (url, params) => instance.post(url, params);
// PUT请求
export const requestPut = (url, params) => instance.put(url, params);

export default instance;



// WEBPACK FOOTER //
// ./src/api/axios.js